export default __webpack_public_path__ + "static/media/repayment-channel-icon9.d9ced142.png";